export default {
  suggestedSearches: {
    id: 'searchbar_suggested_searches_title',
    defaultMessage: 'Suggested searches',
  },
  tabProducts: {
    id: 'catalog_bulk_actions_tab_products',
    defaultMessage: 'Products',
  },
}
